import React from 'react';
import { string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import IconInfo from './icons/IconInfo';


const Tooltip = withStyles(() => ({
  tooltip: {
    fontSize: 14,
    color: '#000',
    background: '#fff',
    border: '1px solid #90a3b7',
    fontWeight: 400,
    fontFamily: '"Open Sans", sans-serif',
    width: 320,
  },
}))(MuiTooltip);

export default function LightTooltip({ title }) {
  return (
    <Tooltip title={title}>
      <span className="MuiButtonBase-root MuiIconButton-root">
        <IconInfo />
      </span>
    </Tooltip>
  );
}

LightTooltip.propTypes = {
  title: string
}
